import React from 'react';
import * as ReactDOM from 'react-dom/client';

import { Root } from './components/Root';

ReactDOM.createRoot(document.querySelector('#app')).render(<Root />);
